<template>
  <div class="col-12">
    <div v-for="(row, index) in value" :key="index">
      <v-row align="center">
        <v-col cols="12" md="5">
          <v-text-field
            :value="row[valueField]"
            :label="valueLabel"
            :error="showErrors && !!rowError(index)"
            :error-messages="showErrors ? rowError(index) : null"
            @input="updateRow(index, valueField, $event)"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="5">
          <v-select
            :value="row[typeField]"
            :items="typeOptions"
            item-text="text"
            item-value="value"
            clearable
            :label="typeLabel"
            @change="updateRow(index, typeField, $event)"
          ></v-select>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn icon :aria-label="removeLabel" @click="removeRow(index)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-btn text color="primary" @click="addRow">
      <v-icon left>mdi-plus</v-icon>{{ addLabel }}
    </v-btn>
    <div v-if="showErrors && limitError" class="error--text">
      {{ limitError }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    valueField: {
      type: String,
      required: true,
    },
    typeField: {
      type: String,
      required: true,
    },
    valueLabel: {
      type: String,
      required: true,
    },
    typeLabel: {
      type: String,
      required: true,
    },
    addLabel: {
      type: String,
      required: true,
    },
    removeLabel: {
      type: String,
      required: true,
    },
    typeOptions: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    errorPrefix: {
      type: String,
      required: true,
    },
    showErrors: Boolean,
    limitError: String,
  },
  methods: {
    rowError(index) {
      return this.errors[this.errorPrefix + index] || null;
    },
    updateRow(index, field, value) {
      const rows = this.value.map((row) => Object.assign({}, row));
      rows[index][field] = value;
      this.$emit("input", rows);
    },
    addRow() {
      const row = {};
      row[this.valueField] = "";
      row[this.typeField] = null;
      this.$emit("input", this.value.concat(row));
    },
    removeRow(index) {
      this.$emit(
        "input",
        this.value.filter((row, rowIndex) => rowIndex !== index)
      );
    },
  },
};
</script>
